//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*eslint-disable*/
import VueSeamless from 'vue-seamless-scroll'
import { toStarString } from '@/common/utils/'
export default {
  name: 'news-scroll',
  props: {
    prizesList: {
      default: () => [],
      type: Array
    }
  },
  filters: {
    initUserName(time) {
      return toStarString(time, false, 3)
    },
  },
  components: {
    VueSeamless
  },
  data() {
    return {
      animate: false,
      defaultOption: {
        step: 4, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 40, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 3000 // 单步运动停止的时间(默认值1000ms)
      },
      index: 0
    }
  },
  methods: {
    scroll() {
      const list = this.$el.querySelector('ul');
      const liHeight = 40;
      this.index++;
      if (this.index === this.prizesList.length) {
        this.index = 0;
      }
      list.style.top = `-${liHeight * this.index}px`;
    },
    handleGoDetail(item) {
      var winDetails = JSON.stringify(item);
      sessionStorage.setItem("betSlip", winDetails);
        this.$router.push({ path: '/betSlip'})
      }
  },
  mounted(){
    setInterval(this.scroll, 4000);
  }
}



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/components/news-scroll.vue